import React, { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";
import { isIOS, isStandalone } from "@/lib/pwa";

const DISMISS_KEY = "creep:install-dismissed";

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY)) return;
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS()) setIosHint(true);
    const onInstalled = () => setDeferred(null);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setDeferred(null);
    setIosHint(false);
  };

  const install = async () => {
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
  };

  if (!deferred && !iosHint) return null;
  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 bottom-24 md:bottom-6 z-50 flex items-center gap-3 pl-4 pr-2 py-2 rounded-full border border-violet-500/40 text-xs text-white shadow-lg"
      style={{ background: "rgba(15,15,20,0.92)", backdropFilter: "blur(16px)" }}
      data-testid="pwa-install-prompt"
    >
      {deferred ? (
        <button onClick={install} className="flex items-center gap-2 font-semibold" data-testid="pwa-install-btn">
          <Download size={14} className="text-violet-300" /> Instalar CREEP
        </button>
      ) : (
        <span className="flex items-center gap-1.5" data-testid="pwa-ios-hint">
          Instálala: <Share size={13} className="text-violet-300" /> Compartir → «Añadir a pantalla de inicio»
        </span>
      )}
      <button onClick={dismiss} aria-label="Cerrar" className="w-7 h-7 rounded-full hover:bg-white/10 flex items-center justify-center" data-testid="pwa-install-dismiss">
        <X size={13} />
      </button>
    </div>
  );
};
